define("shared/components/shared/base-time-picker", ["exports", "@ember/component", "@ember/debug", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "flatpickr", "flatpickr/dist/l10n/de.js", "flatpickr/dist/l10n/es.js", "flatpickr/dist/l10n/fr.js", "shared/utils/create-flatpickr-config", "shared/utils/uuid", "@ember/template-factory"], function (_exports, _component, _debug, _object, _service, _component2, _tracking, _flatpickr, _de, _es, _fr, _createFlatpickrConfig, _uuid, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"flatpickr",0,"flatpickr/dist/l10n/de.js",0,"flatpickr/dist/l10n/es.js",0,"flatpickr/dist/l10n/fr.js",0,"shared/utils/create-flatpickr-config",0,"shared/utils/uuid",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class={{concat-classes
      @pickerClass
      @errorClass
      "qa--postModal_timePicker_dropdown"
      (if @disabled "o--btn--disabled")
    }}
    data-test-id="time-picker"
    id={{@pickerId}}
    {{did-insert this.setup}}
    {{did-update (fn this.setDateRange @startDate @endDate) @startDate @endDate}}
    {{did-update this.setup @disabled}}
    {{on "click" this.open}}
  >
    {{yield this.pickerInputId to="beforeInput"}}
    <Input
      @type="text"
      class={{if @inputClass (concat-classes @inputClass "qa--birthday_picker_dropdown") "qa--birthday_picker_dropdown"}}
      data-input
      data-test-id="time-picker-input"
      disabled={{@disabled}}
      id={{this.pickerInputId}}
      placeholder={{@placeholder}}
    />
    {{yield to="afterInput"}}
  </div>
  {{#if this.isCalendarOpen}}
    <Shared::Portal @destinationElement={{this.pickerCalendarId}} @renderInTest={{true}} @shouldAppend={{true}}>
      {{yield (hash setDate=this.setDateRange close=this.close) to="calendarSiblingContent"}}
    </Shared::Portal>
    <Shared::Portal @destinationElement={{this.pickerCalendarId}} @renderInTest={{true}} @shouldAppend={{true}}>
      {{yield (hash setDate=this.setDate close=this.close) to="calendarAfterContent"}}
    </Shared::Portal>
  {{/if}}
  */
  {
    "id": "4uVbqp/W",
    "block": "[[[11,0],[16,0,[28,[37,0],[[30,1],[30,2],\"qa--postModal_timePicker_dropdown\",[52,[30,3],\"o--btn--disabled\"]],null]],[24,\"data-test-id\",\"time-picker\"],[16,1,[30,4]],[4,[38,2],[[30,0,[\"setup\"]]],null],[4,[38,3],[[28,[37,4],[[30,0,[\"setDateRange\"]],[30,5],[30,6]],null],[30,5],[30,6]],null],[4,[38,3],[[30,0,[\"setup\"]],[30,3]],null],[4,[38,5],[\"click\",[30,0,[\"open\"]]],null],[12],[1,\"\\n  \"],[18,9,[[30,0,[\"pickerInputId\"]]]],[1,\"\\n  \"],[8,[39,7],[[16,0,[52,[30,7],[28,[37,0],[[30,7],\"qa--birthday_picker_dropdown\"],null],\"qa--birthday_picker_dropdown\"]],[24,\"data-input\",\"\"],[24,\"data-test-id\",\"time-picker-input\"],[16,\"disabled\",[30,3]],[16,1,[30,0,[\"pickerInputId\"]]],[16,\"placeholder\",[30,8]]],[[\"@type\"],[\"text\"]],null],[1,\"\\n  \"],[18,10,null],[1,\"\\n\"],[13],[1,\"\\n\"],[41,[30,0,[\"isCalendarOpen\"]],[[[1,\"  \"],[8,[39,8],null,[[\"@destinationElement\",\"@renderInTest\",\"@shouldAppend\"],[[30,0,[\"pickerCalendarId\"]],true,true]],[[\"default\"],[[[[1,\"\\n    \"],[18,11,[[28,[37,9],null,[[\"setDate\",\"close\"],[[30,0,[\"setDateRange\"]],[30,0,[\"close\"]]]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n  \"],[8,[39,8],null,[[\"@destinationElement\",\"@renderInTest\",\"@shouldAppend\"],[[30,0,[\"pickerCalendarId\"]],true,true]],[[\"default\"],[[[[1,\"\\n    \"],[18,12,[[28,[37,9],null,[[\"setDate\",\"close\"],[[30,0,[\"setDate\"]],[30,0,[\"close\"]]]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]],null]],[\"@pickerClass\",\"@errorClass\",\"@disabled\",\"@pickerId\",\"@startDate\",\"@endDate\",\"@inputClass\",\"@placeholder\",\"&beforeInput\",\"&afterInput\",\"&calendarSiblingContent\",\"&calendarAfterContent\"],false,[\"concat-classes\",\"if\",\"did-insert\",\"did-update\",\"fn\",\"on\",\"yield\",\"input\",\"shared/portal\",\"hash\"]]",
    "moduleName": "shared/components/shared/base-time-picker.hbs",
    "isStrictMode": false
  });
  /**
   * This component provides a wrapper around Flatpickr.
   * For available options see: lib/shared/app/models/flatpickr-config.js
   */
  let BaseTimePickerComponent = _exports.default = (_class = class BaseTimePickerComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "locale", _descriptor, this);
      _initializerDefineProperty(this, "userConfig", _descriptor2, this);
      _defineProperty(this, "pickerInputId", `date-picker-${(0, _uuid.default)()}`);
      _defineProperty(this, "pickerCalendarId", `date-picker-calendar-${(0, _uuid.default)()}`);
      _initializerDefineProperty(this, "flatpickr", _descriptor3, this);
      _initializerDefineProperty(this, "isCalendarOpen", _descriptor4, this);
    }
    get timezoneIdentifier() {
      const identifier = this.userConfig.currentTimeZone?.identifier;
      (false && !(identifier) && (0, _debug.assert)('Must pass a valid timezone identifier', identifier));
      return identifier;
    }
    get appendToContainer() {
      if (this.args.pickerContainerId) {
        const pickerContainer = document.getElementById(this.args.pickerContainerId);
        return Boolean(this.args.pickerContainerId && pickerContainer);
      }
      return false;
    }
    get flatpickrLocale() {
      switch (this.locale?.primaryLocale) {
        case 'de':
          return _de.German;
        case 'es':
          return _es.Spanish;
        case 'fr':
          return _fr.French;
        default:
          return undefined;
      }
    }
    setup(element) {
      const pickerContainer = this.args.pickerContainerId ? document.getElementById(this.args.pickerContainerId) || undefined : undefined;
      const config = (0, _createFlatpickrConfig.default)({
        onClose: this.handleClose,
        onOpen: this.handleOpen,
        dateFormat: 'F j, Y',
        defaultDate: this.locale.formatToDefaultDateRange(this.args.startDate, this.args.endDate),
        ...this.args.config,
        ...(this.appendToContainer && {
          appendTo: pickerContainer
        }),
        ...(this.flatpickrLocale && {
          locale: this.flatpickrLocale
        })
      }, this.timezoneIdentifier);
      this.flatpickr = (0, _flatpickr.default)(element, config);
      this.args.setFlatpickrReference?.(this.flatpickr);
      this.flatpickr.calendarContainer.id = this.pickerCalendarId;
      this.appendToContainer && this.flatpickr.calendarContainer.classList.add('appended');
    }
    willDestroy() {
      super.willDestroy();
      if (typeof this.flatpickr?.destroy === 'function') {
        this.flatpickr.destroy();
      }
    }
    handleOpen() {
      this.isCalendarOpen = true;
      this.args.onOpen?.();
    }
    open() {
      if (typeof this.flatpickr?.open === 'function') {
        this.flatpickr.open();
      }
    }
    handleClose(selectedDates) {
      if (this.args.config.mode === 'range' && selectedDates.length <= 1) {
        this.setDate(this.args.startDate || '');
      }
      this.isCalendarOpen = false;
      this.args.onClose?.(selectedDates);
    }
    close(selectedDates) {
      if (typeof this.flatpickr?.close === 'function') {
        this.flatpickr.close();
        this.handleClose(selectedDates);
      }
    }
    setDateRange(startDate, endDate) {
      if (typeof this.flatpickr?.setDate === 'function') {
        const dateTimeArray = this.locale.formatToDefaultDateRange(startDate, endDate);
        this.flatpickr.setDate(dateTimeArray, false);
        this.flatpickr.jumpToDate(dateTimeArray[0], true);
      }
    }
    setDate(date) {
      if (typeof this.flatpickr?.setDate === 'function') {
        this.flatpickr.setDate(date);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "locale", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "flatpickr", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isCalendarOpen", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "setup", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleOpen", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "open", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "open"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleClose", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setDateRange", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setDateRange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setDate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setDate"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BaseTimePickerComponent);
});